/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The available sort by criteria to choose from.
 */
export type UsersSortByParam =
  (typeof UsersSortByParam)[keyof typeof UsersSortByParam];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersSortByParam = {
  FIRST_NAME_ASC: "FIRST_NAME_ASC",
  FIRST_NAME_DESC: "FIRST_NAME_DESC",
  LAST_NAME_ASC: "LAST_NAME_ASC",
  LAST_NAME_DESC: "LAST_NAME_DESC",
  EMAIL_ASC: "EMAIL_ASC",
  EMAIL_DESC: "EMAIL_DESC",
  UPDATED_AT_ASC: "UPDATED_AT_ASC",
  UPDATED_AT_DESC: "UPDATED_AT_DESC",
} as const;
